import { SystemStage, type System } from '../core/System';
import { type Scene } from '../scene/Scene';

/**
 * Runs every behavior's `onUpdate` once per frame.
 *
 * Entities update in creation order and behaviors within an entity in attach order, so a frame is
 * reproducible. Inactive entities are skipped, and so are entities whose ancestors are inactive.
 *
 * Iteration works from snapshots at both levels, which is what makes destroying an entity, adding a
 * behavior or spawning a sibling from inside `onUpdate` safe rather than a mid-iteration hazard.
 */
export class BehaviorSystem implements System {
  /** Behaviors run after input and before collision. */
  readonly stage = SystemStage.Behaviors;

  /** Updates every behavior on every active entity. */
  onUpdate(scene: Scene, deltaSeconds: number): void {
    for (const entity of scene.entities) {
      if (entity.destroyed || !entity.activeInHierarchy) {
        continue;
      }

      for (const behavior of [...entity.behaviors]) {
        if (entity.destroyed) {
          break;
        }
        behavior.onUpdate?.(deltaSeconds);
      }
    }
  }
}
